import { serializeEmbedParams } from "@videojs/media/dom";
//#region src/source.ts
/** Extract a TikTok video id from a raw numeric id or any recognized URL. */
function parseTikTokVideoId(src) {
	return parseTikTokSource(src)?.id ?? null;
}
/**
* Parse a TikTok source string. Recognizes raw numeric ids, `player/v1/` embed URLs, `share/video/` links, and the
* `@user/video/` URLs the app hands out.
*/
function parseTikTokSource(src) {
	if (!src) return null;
	if (MATCH_ID.test(src)) return { id: src };
	const id = MATCH_SRC.exec(src)?.[1];
	return id ? { id } : null;
}
/**
* Whether the embed has to carry an `autoplay` nobody asked for. TikTok builds its player lazily: without one it
* creates no media element, never reports `onPlayerReady`, and drops every command silently, until something is clicked
* inside the frame — which a frame under a player skin never gets. The host parks the player as soon as it is up, so
* this buys one that answers commands, not a video that plays.
*/
function shouldBootstrapTikTokEmbed(props = {}) {
	return !props.autoplay && props.preload !== "none" && props.controls !== true;
}
/** Build the iframe `src` URL for a TikTok embed from the given props. */
function buildTikTokIframeSrc(src, props = {}) {
	const parsed = parseTikTokSource(src);
	if (!parsed) return "";
	const { referrerPolicy: _referrerPolicy, ...tiktok } = props.source?.engine?.tiktok ?? {};
	const params = {
		controls: props.controls === true ? null : 0,
		autoplay: props.autoplay || shouldBootstrapTikTokEmbed(props) || null,
		muted: props.defaultMuted || null,
		loop: props.loop || null,
		rel: 0,
		...tiktok
	};
	return `${EMBED_BASE}/${parsed.id}?${serializeEmbedParams(params)}`;
}
const EMBED_BASE = "https://www.tiktok.com/player/v1";
const MATCH_ID = /^\d+$/;
const MATCH_SRC = /tiktok\.com\/(?:player\/v1\/|share\/video\/|@[^/]+\/video\/)(\d+)/;
//#endregion
export { buildTikTokIframeSrc, parseTikTokSource, parseTikTokVideoId, shouldBootstrapTikTokEmbed };
